module.exports = __webpack_public_path__ + "media/images/brands/marque-peggy-sage-683b2e0cad72e7ad807be38c92ed01db.jpg";